// extracted by mini-css-extract-plugin
export default {"main":"socialMediaShare_main__Hjo0u","icon":"socialMediaShare_icon__yJpeb"};